module.exports = __webpack_public_path__ + "img/Sharing2.ecbcf990.svg";